(() => {
  if (window.hlNavigationLoaded) return;
  window.hlNavigationLoaded = true;
  const activateCategory = event => {
    const link = event.target.closest('[data-hl-category]');
    if (!link) return;
    const category = link.closest('.hl-navigation__category');
    if (!category || category.classList.contains('is-active')) return;
    category.parentElement.querySelectorAll(':scope > .hl-navigation__category').forEach(item => {
      item.classList.toggle('is-active', item === category);
    });
  };
  document.addEventListener('pointerover', activateCategory);
  document.addEventListener('focusin', activateCategory);
  document.addEventListener('click', event => {
    document.querySelectorAll('.hl-navigation__catalogue[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.hl-navigation__catalogue[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  }, true);
})();
